import { ReactComponent as CogIcon } from '../../../assets/icons/cog.svg';
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar.svg';
import { ReactComponent as ButtonIcon } from '../../../assets/icons/button.svg';
import { ReactComponent as BuddyPressIcon } from '../../../assets/icons/buddypress.svg';
import { ReactComponent as TimeIcon } from '../../../assets/icons/time.svg';
import { ReactComponent as ShortCode } from '../../../assets/icons/shortcode.svg';
import { ReactComponent as BookrCopy } from '../../../assets/icons/copy.svg';
import { ReactComponent as Spinner } from '../../../assets/icons/spinner.svg';
import { ReactComponent as Delete } from '../../../assets/icons/delete.svg';
import { ReactComponent as CustomerService } from '../../../assets/icons/customer-service.svg';

// Typen für die Icon-Liste
export type IconName = 'cog' | 'calendar' | 'button' | 'buddypress' | 'time' | 'shortcode' | 'copy' | 'spinner' | 'delete' | 'customerService';

type SvgIconProps = {
	name: IconName;
	size?: number;
	color?: string;
};

const icons = {
	cog: CogIcon,
	calendar: CalendarIcon,
	button: ButtonIcon,
	buddypress: BuddyPressIcon,
	time: TimeIcon,
	shortcode: ShortCode,
	copy: BookrCopy,
	spinner: Spinner,
	delete: Delete,
	customerService: CustomerService,
};

export const SvgIcon: React.FC<SvgIconProps> = ({ name, size = 24, color = '#727E95' }) => {
	const IconComponent = icons[name]; // Wähle das Icon basierend auf dem Namen
	if (!IconComponent) {
		console.error(`Icon "${name}" not found.`);
		return null;
	}
	return <IconComponent width={size} height={size} fill={color} />;
};
